import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useEvidenceToolStore } from '@/store/useEvidenceToolStore';
import { EVIDENCE_TOOLS, type EvidenceToolId } from './EvidenceToolRegistry';

interface EvidenceToolSwitchProps {
  current: EvidenceToolId;
  disabled?: boolean;
}

// Renders a button for every evidence tool that is not the current one, so registering a
// third tool gives every existing tool a way to reach it without touching this file.
export function EvidenceToolSwitch({ current, disabled }: EvidenceToolSwitchProps) {
  const activateTool = useEvidenceToolStore((state) => state.activateTool);

  return (
    <>
      {EVIDENCE_TOOLS.filter((tool) => tool.id !== current).map((tool) => {
        const Icon = tool.icon;
        return (
          <Tooltip key={tool.id}>
            <TooltipTrigger asChild>
              <span className="inline-flex">
                <Button
                  data-testid={`evidence-tool-switch-${tool.id}`}
                  type="button"
                  variant="ghost"
                  size="icon"
                  className="h-7 w-7"
                  disabled={disabled}
                  onClick={() => activateTool(tool.id)}
                  title={tool.switchTitle}
                >
                  <Icon className="h-3.5 w-3.5" />
                </Button>
              </span>
            </TooltipTrigger>
            <TooltipContent className="mr-2" sideOffset={4}>
              <p>{tool.switchTitle}</p>
            </TooltipContent>
          </Tooltip>
        );
      })}
    </>
  );
}
